import { IInfinitePageResponse } from 'services/types';

export interface settlementPeriodName {
  name: string;
  year: number;
}

export interface ISettlementParams {
  pageSize?: number;
  page?: number;
}

export interface IResponseSettlementPeriodsLightList {
  id: string;
  settlementPeriodName: settlementPeriodName;
  settlementPeriodType: SettlementPeriodType;
}

export interface IResponsSettlementPeriods {
  id: string;
  settlementPeriodName: settlementPeriodName;
  startDate: string;
  endDate: string;
  settlementPeriodType: SettlementPeriodType;
}

export interface SettlementPeriodType {
  id: SETTLEMENT_PERIOD_TYPE_ENUM;
  name: string;
}
export enum SETTLEMENT_PERIOD_TYPE_ENUM {
  unknown = -1,
  Month = 1,
  Quarter = 2,
  HalfYear = 3,
  Year = 4,
}

export interface ISettlementPeriods extends IInfinitePageResponse<IResponsSettlementPeriods>{
}

interface SettlementPeriodName {
  name: string;
  year: any;
}

export interface SettlementPeriod {
  id: string;
  settlementPeriodName: SettlementPeriodName;
}

export interface SettlementPeriodOption {
  value: string;
  label: string;
}
